import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { staffdetails } from "../api/Users";
import { toast } from "react-toastify";

const ContactDetail = ({ role, userData }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    setIsLoading(true);
    let data = {
      school_id: userData.data.school_id,
    };
    staffdetails(data)
      .then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data.staff_data);
          console.log(setFilteredData);
        } else {
          setFilteredData([]);
          toast.error(t("Something went wrong"));
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleImageClick = (imageData) => {
    var w = window.open("about:blank");
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement("iframe")).src =
        "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = "100%";
      w.document.getElementsByTagName("iframe")[0].style.height = "100%";
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t(" ")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} 
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", 
              }}
            />
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table  aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell >{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Full Name")}</TableCell>
                  <TableCell align="center">{t("Role/Position")}</TableCell>
                  <TableCell align="center">{t("Contact no.")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!isLoading &&
                  filteredData &&
                  filteredData
                    .filter((item) =>
                      item.teacher_name.toLowerCase().includes(searchQuery.toLowerCase())||
                      item.Category_of_post_held.toLowerCase().includes(searchQuery.toLowerCase())
                    )
                    .slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell align="center">{row.teacher_name}</TableCell>
                        <TableCell align="center">{row.Category_of_post_held}</TableCell>
                        <TableCell align="center">{row.teacher_contact_no}</TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default ContactDetail;
